<template>
  <!-- eslint-disable max-len -->
  <footer
    ref="footer"
    class="bg-black p-8 w-full text-white relative text-4 flex justify-between md:items-center flex-col md:flex-row"
  >
    <div>
      <RouterLink
        :to="{ name: 'legal' }"
      >
        Legal
      </RouterLink>
      <p
        class="pt-4"
        v-text="footerText"
      />
    </div>
    <div class="flex mt-8 md:mt-0">
      <img
        class="logo-size mr-8"
        :src="require('@assets/img/nrla.png')"
      >
      <img
        class="logo-size"
        :src="require('@assets/img/mydeposits.png')"
      >
    </div>
  </footer>
</template>

<script>
import { global } from '@io';

export default {
  name: 'BlockFooter',

  data: () => ({
    footerText: null,
  }),

  async mounted() {
    // Get data
    this.footerText = await global.get('footerText');
  },
};
</script>

<style scoped>
.logo-size {
  max-height: 4rem;
}
</style>
